import { useState } from "react";

import { PersonalizedReports } from "@/features/today";

import BackArrow from "@/assets/img/profile/back_arrow.svg?react";

import { ProfileHero } from "./profile-hero";
import { StarsBalance } from "./stars-balance";
import { HelpAndLegal } from "./help-and-legal";
import { EditProfileModal } from "./edit-profile-modal";
import { MyPlanModal } from "./my-plan-modal";
import { SavedToast } from "./saved-toast";
import { AdvisorsQuizModal } from "./advisors-quiz/advisors-quiz-modal";
import { StarsPurchaseModal } from "./stars-purchase-modal";

interface ProfileModalProps {
  onClose: () => void;
}

/** Full-screen profile modal opened from the header. Ported from ProfileV4. */
export function ProfileModal({ onClose }: ProfileModalProps) {
  const [showEdit, setShowEdit] = useState(false);
  const [showSaved, setShowSaved] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showPlan, setShowPlan] = useState(false);
  const [showStarsPurchase, setShowStarsPurchase] = useState(false);

  return (
    <div className="fixed inset-0 z-[1000] mx-auto max-h-[100dvh] w-full max-w-app overflow-y-auto bg-dark-base [scrollbar-width:none]">
      <button
        type="button"
        onClick={onClose}
        className="absolute left-4 top-4 z-[1] [&_svg]:size-6"
      >
        <BackArrow />
      </button>

      <ProfileHero onEdit={() => setShowEdit(true)} />
      <StarsBalance onTopUp={() => setShowStarsPurchase(true)} />
      <PersonalizedReports />
      {/* <AccountStatistics /> */}
      <HelpAndLegal
        onEditProfile={() => setShowEdit(true)}
        onFindAdvisor={() => setShowQuiz(true)}
        onMyPlan={() => setShowPlan(true)}
      />

      <p className="mx-auto mb-6 text-center font-body text-sm text-purple-light/70">
        All rights reserved. {new Date().getFullYear()}
      </p>

      {showEdit && (
        <EditProfileModal
          onClose={() => setShowEdit(false)}
          onSaved={() => {
            setShowEdit(false);
            setShowSaved(true);
          }}
        />
      )}
      {showSaved && <SavedToast onDone={() => setShowSaved(false)} />}
      {showQuiz && (
        <AdvisorsQuizModal
          onClose={() => setShowQuiz(false)}
          onStarted={onClose}
        />
      )}
      {showPlan && <MyPlanModal onClose={() => setShowPlan(false)} />}
      {showStarsPurchase && (
        <StarsPurchaseModal onClose={() => setShowStarsPurchase(false)} />
      )}
    </div>
  );
}
